export default {
  wrapper: {
    position: 'relative',
    display: 'inline-block',
    verticalAlign: 'middle',
    marginRight: '10px',
    transform: 'scale(.85) translateY(-7%)'
  },
  circle: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: 0,
    top: 0
  },
  circleBefore: {
    margin: '0 auto',
    width: '15%',
    height: '15%',
    borderRadius: '100%',
    animation: 'spinnerCircleFade 1.2s infinite ease-in-out both',
    position: 'relative',
    transform: 'translate(0, -50%)'
  },
  '@keyframes spinnerCircleFade': {
    '0%, 39%, 100%': {
      opacity: 0
    },
    '40%': {
      opacity: 1
    }
  }
};